"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const textManipulations_1 = require("../../helpers/textManipulations");
const FormattedNumberConsts_1 = require("./FormattedNumberConsts");
const FormattedNumberHelpers_1 = require("./FormattedNumberHelpers");
require("./FormattedNumber.scss");
const FormattedNumber = (0, react_1.forwardRef)(({ value, className, local = FormattedNumber.localFallBack, prefix, suffix, emptyPlaceHolder = "N/A", decimalPrecision = 2, compact = true, rtl }, ref) => {
    const renderSuffix = (0, react_1.useMemo)(() => {
        if (!suffix)
            return null;
        return (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${FormattedNumberConsts_1.baseClassName}__suffix` }, { children: suffix }));
    }, [suffix]);
    const renderPrefix = (0, react_1.useMemo)(() => {
        if (!prefix)
            return null;
        return (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${FormattedNumberConsts_1.baseClassName}__prefix` }, { children: prefix }));
    }, [prefix]);
    const calculatedValue = (0, react_1.useMemo)(() => {
        return (0, textManipulations_1.formatNumber)(Number(value), {
            local,
            precision: decimalPrecision,
            isCompact: compact
        });
    }, [value, decimalPrecision, local, compact]);
    if ((0, FormattedNumberHelpers_1.validateValue)(value)) {
        return (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${FormattedNumberConsts_1.baseClassName}__place-holder` }, { children: emptyPlaceHolder }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: ref, className: (0, classnames_1.default)(className, FormattedNumberConsts_1.baseClassName) }, { children: [rtl ? renderSuffix : renderPrefix, (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${FormattedNumberConsts_1.baseClassName}__number` }, { children: calculatedValue })), rtl ? renderPrefix : renderSuffix] })));
});
FormattedNumber.formatNumber = textManipulations_1.formatNumber;
FormattedNumber.localFallBack = textManipulations_1.formatNumberConsts.DEFAULT_LOCAL;
exports.default = FormattedNumber;
